import { useEffect } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import Animated, {
  useAnimatedProps,
  useSharedValue,
  withTiming,
} from 'react-native-reanimated';
import Svg, { Circle } from 'react-native-svg';

import { Fonts, Palette } from '@/constants/theme';

const AnimatedCircle = Animated.createAnimatedComponent(Circle);

const SIZE = 52;
const STROKE = 5;
const RADIUS = (SIZE - STROKE) / 2;
const CIRCUMFERENCE = 2 * Math.PI * RADIUS;

export function ProfileRing({ pct }: { pct: number }) {
  const target = Math.max(0, Math.min(100, pct));
  const progress = useSharedValue(0);

  useEffect(() => {
    progress.value = withTiming(target / 100, { duration: 720 });
  }, [target, progress]);

  const animatedProps = useAnimatedProps(() => ({
    strokeDashoffset: CIRCUMFERENCE * (1 - progress.value),
  }));

  return (
    <View>
      <View style={styles.wrap}>
        <Svg width={SIZE} height={SIZE} style={styles.svg}>
          <Circle
            cx={SIZE / 2}
            cy={SIZE / 2}
            r={RADIUS}
            stroke={Palette.line}
            strokeWidth={STROKE}
            fill="none"
          />
          <AnimatedCircle
            cx={SIZE / 2}
            cy={SIZE / 2}
            r={RADIUS}
            stroke={Palette.forest}
            strokeWidth={STROKE}
            strokeLinecap="round"
            fill="none"
            strokeDasharray={CIRCUMFERENCE}
            animatedProps={animatedProps}
            transform={`rotate(-90 ${SIZE / 2} ${SIZE / 2})`}
          />
        </Svg>
        <View style={styles.pctWrap} pointerEvents="none">
          <Text style={styles.pctText}>{target}%</Text>
        </View>
      </View>
      <Text style={styles.label}>PROFILE</Text>
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: {
    width: SIZE,
    height: SIZE,
  },
  svg: {
    position: 'absolute',
    top: 0,
    left: 0,
  },
  pctWrap: {
    ...StyleSheet.absoluteFillObject,
    alignItems: 'center',
    justifyContent: 'center',
  },
  pctText: {
    fontFamily: Fonts.sansBold,
    fontSize: 13,
    color: Palette.forest,
  },
  label: {
    marginTop: 1,
    textAlign: 'center',
    fontSize: 10.5,
    fontFamily: Fonts.sansBold,
    // Mid-grey for legibility against the cream backdrop. inkFaint
    // bordered on invisible — multiple user reports.
    color: Palette.inkSoft,
    letterSpacing: 0.6,
  },
});
